import { FormattedMessage } from 'react-intl';
import { errorCommonI18n } from '@_/i18n-common';
import { Link } from '@_/ui';
import { Page } from '#src/components/Page/index.ts';
import { navI18n } from '#src/i18nMessages/index.ts';

export function NotFoundPage() {
  return (
    <Page centerContent screenHeight>
      <div className="text-center">
        <p className="text-sm font-semibold tracking-wide text-primary-600 uppercase">
          <FormattedMessage {...errorCommonI18n['404Page'].code} />
        </p>
        <h1 className="mt-2 text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
          <FormattedMessage {...errorCommonI18n['404Page'].heading} />
        </h1>
        <p className="mt-2 text-base text-gray-500">
          <FormattedMessage {...errorCommonI18n['404Page'].description} />
        </p>
        <div className="mt-6">
          <Link from="/{-$locale}" to="/{-$locale}">
            <FormattedMessage {...navI18n.goBackHome} />
            <span> &rarr;</span>
          </Link>
        </div>
      </div>
    </Page>
  );
}
